
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getSentRecordsList } from "@/api/api-basic-sms";
import { getOptionList, optionKey } from "@/api/api-dict";
import PiExport from "@/components/pi-export/pi-export.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-export": PiExport
  }
})
export default class PurchaseRecord extends Vue {
  private messageTypeList: object[] = [];
  private agentList: object[] = [
    { itemKey: "1", itemValue: i18n.t("messageRecord.pilot") },
    { itemKey: "2", itemValue: i18n.t("messageRecord.aliCloud") }
  ];

  private total = 0;
  private loading = false;

  private auditMadel: objAny = {};
  private formInline: objAny = {
    beginTime: "",
    endTime: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    agent: "",
    bussType: ""
  };

  private time: object[] = [];
  private tableList: object[] = [{}];
  private tableColumns: object[] = [
    {
      title: i18n.t("oprName"),
      key: "oprName",
      minWidth: 120
    },
    {
      title: i18n.t("messageRecord.sendTime"),
      key: "sendTime",
      minWidth: 140
    },
    {
      title: i18n.t("messageRecord.bussType"),
      key: "bussTypeDesc",
      minWidth: 120
    },
    {
      title: i18n.t("messageRecord.content"),
      key: "content",
      minWidth: 180
    },
    {
      title: i18n.t("messageRecord.phoneNo"),
      key: "phoneNo",
      minWidth: 110
    },
    {
      title: i18n.t("messageRecord.status"),
      key: "statusDesc",
      minWidth: 120
    }
  ];

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getSentRecordsList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.beginTime = val[0];
      this.formInline.endTime = val[1];
    } else {
      this.formInline.beginTime = "";
      this.formInline.endTime = "";
    }
  }
  async getOptionList() {
    const ret = await getOptionList([optionKey.wxBussType]); //请求字典
    this.messageTypeList = ret[optionKey.wxBussType];
  }

  mounted() {
    this.getOptionList();
    const startTime = this.$common.thisTimes("yyyy-MM") + "-01";
    const time = this.$common.thisTimes("yyyy-MM-dd");
    this.time = [startTime, time];
    this.formInline.beginTime = startTime;
    this.formInline.endTime = time;
    this.getTableList();
    this.$nextTick(() => {
      this.auditMadel = this.$refs.auditMadel;
    });
  }
}
